import { DateTime } from "luxon";
import { Day } from "src/app/core/day.model";
import { TimeOfDay } from "src/app/core/time-of-day.model";

export const datePickerTimeZone = Day.localZone;
export const datePickerFixedTime = TimeOfDay.midnight;

export function getAdjustedDateTime(value: Day): DateTime {
  return value.toDateTime(datePickerFixedTime, datePickerTimeZone);
}
